import React, { useEffect } from "react";
import Header from "./Header";
import Main from "./Main";
import Join from "../../Join";
import Footer from "../../Footer";
import Benefits from "./Benefits";
import Roles from "./Roles";
import Experience from "./Experience";

const Company2 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    return () => {};
  }, []);
  return (
    <>
      <Header />
      <Main />
      <Experience />
      <Benefits />
      <Roles />
      <Join />
      <Footer />
    </>
  );
};

export default Company2;
